import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { PlatformDialogTestComponent } from '../../platform/platform-dialog-test/platform-dialog-test.component';

@Component({
  selector: 'app-ranking-modal',
  templateUrl: './ranking-modal.component.html',
  styleUrls: ['./ranking-modal.component.scss'],
})
export class RankingModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<RankingModalComponent>
  ) {}

  openPlatform(data: any) {
    this.dialogRef.close();
    this.dialog.open(PlatformDialogTestComponent, {
      data: Object.assign({}, data),
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }
}
